module.exports = __webpack_public_path__ + "img/Impressions.860d4ee2.svg";